import { createContext } from 'react';

export const ResyncOtpContext = createContext();
export const ResyncOtpDispatchContext = createContext();
